import { htmlToText } from 'html-to-text';
import styled from 'styled-components';
/**
 * Renders the given `html` string and applies basic styling to the rendered elements (i.e. paragraphs, lists, etc.).
 * TODO: Sanitize input
 *
 * @example
 * <Text variant="copy1">
 *   <RenderHtml html={data.message} />
 * </Text>
 */
export function RenderHtml({ html, className }: { html: string | null | undefined; className?: string }) {
	if (!html) {
		return null;
	}

	return (
		<StyledProse className={className}>
			<span dangerouslySetInnerHTML={{ __html: html }} />
		</StyledProse>
	);
}

export function RenderShortendedText({ html }: { html: string | null | undefined }) {
	if (!html) return <></>;

	const result = getShortenedText(
		htmlToText(html, {
			preserveNewlines: true,
			formatters: {
				anchor: (el, walk, builder) => {
					builder.openBlock();
					walk(el.children, builder);
					builder.closeBlock();
				},
			},
		}),
	);

	return (
		<StyledProse>
			<span>{result}</span>
		</StyledProse>
	);
}

function getShortenedText(text: string) {
	if (text.length <= 144) return text;
	return text.substring(0, 144) + '…';
}

const StyledProse = styled.span`
	p:not(:last-child) {
		margin-bottom: 1rem;
	}

	li {
		display: flex;
		padding-left: 0;
	}

	li::before {
		content: '•'; /* Manually add the bullet */
		margin-right: 6px; /* Space between bullet and text */
		font-size: 10px; /* Size of the bullet */
		line-height: 20px;
	}
`;
